import _ from 'lodash';
import angular from 'angular';
import { sha256 } from 'js-sha256';
import * as api from 'lsp/lsp.api';
import DepsService from 'services/dependencies';

function createNgFactory(FactoryClass) {
  return (FactoryClass.$inject || []).concat((...args) => new FactoryClass(...args));
}

function pageHeader(menu, key, value) {
  const obj = _.find(menu, [key, value]);
  return obj ? obj.title || obj.label : '';
}

function jsonObjectParameter(filterName) {
  return {
    name: filterName,
    decode(val) {
      return val ? JSON.parse(val) : {};
    },
    encode(val) {
      return JSON.stringify(val);
    },
    equals(a, b) {
      return this.is(a) && this.is(b) && a.fileType === b.fileType;
    },
    is(val) {
      return angular.isObject(val);
    },
  };
}

function randomString(len, charSet) {
  charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < len; i++) {
    const randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
}

function getHashes(code, salts) {
  if (!code) return;
  const codeBytes = [];
  for (let i = 0; i < code.length; i++) {
    codeBytes.push(code.charCodeAt(i));
  }

  if (salts && salts.length > 0) {
    return salts.map((salt) => {
      const bytes = [];
      for (let c = 0; c < salt.length; c += 2) {
        bytes.push(parseInt(salt.substr(c, 2), 16));
      }
      return sha256(codeBytes.concat(bytes));
    });
  } else {
    return [code];
  }
}

function redirectToLSP(redirectionUrlType, adminId, alertId = null) {
  api.fetchRedirectDetails(redirectionUrlType, adminId, alertId).then((results) => {
    if (results.redirectDto.tokenType === 'JWT') {
      const form = window.document.createElement('form');
      form.method = 'POST';
      form.target = '_blank';
      form.action = results.baseUrl;
      for (let prop in results.redirectDto) {
        const input = window.document.createElement('input');
        input.type = 'hidden';
        input.name = prop;
        input.value = results.redirectDto[prop];
        form.append(input);
      }
      window.document.body.appendChild(form);
      form.submit();
    }
  });
}

function getShippingPartnerLink(prefixedTrackingNumber) {
  const shippingPartnerLink = DepsService.config.shippingPartnerLinks.find((link) => {
    const regExp = new RegExp(link.regex);
    return regExp.test(prefixedTrackingNumber);
  });
  return shippingPartnerLink ? shippingPartnerLink.url + prefixedTrackingNumber : prefixedTrackingNumber;
}

export default {
  createNgFactory,
  pageHeader,
  jsonObjectParameter,
  randomString,
  getHashes,
  redirectToLSP,
  getShippingPartnerLink,
};



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-utils-service.js